import { z } from "zod";

export const HeroV2CtaTypeSchema = z.object({
  additionalBehavior: z.union([
    z.literal(null),
    z.enum(["onlyForLoggedIn", "onlyForNotLoggedIn", "always"]),
  ]),
  link: z.string(),
  label: z.string(),
  theme: z.enum(["light", "dark"]),
  layout: z.enum(["chevron", "full", "border"]),
  tracking: z.string(),
  target: z.enum(["_blank", ""]),
});

export const DiscountSchema = z.object({
  currentPrice: z.string(),
  originalPrice: z.string(),
  packInformation: z.string(),
  priceDisclaimer: z.string(),
});

const HeroBaseSchema = z.object({
  clipped: z.boolean(),
  content: z.object({
    title: z.string(),
    tagLine: z.string(),
    text: z.string(),
    cta: z.array(HeroV2CtaTypeSchema),
    discounts: z.array(DiscountSchema),
  }),
  displayLoader: z.boolean(),
  displayScrollBar: z.boolean(),
  legalDisclaimer: z.string(),
  logo: z.string().optional(),
  mobileVariant: z.enum([
    "transparentContentOnTop",
    "contentAtTheBottomWithBackground",
  ]),
  removeVideoRoundedCorners: z.boolean().optional(),
  gradientPosition: z.enum(["top", "left", "none"]).optional(),
});
const ImageSchema = z.object({
  src: z.string(),
  alt: z.string(),
  title: z.string(),
});

const OptionalImageSchema = z.object({
  src: z.string().optional(),
  alt: z.string().optional(),
  title: z.string().optional(),
});

const HeroWithImageSchema = HeroBaseSchema.merge(
  z.object({
    backgroundType: z.literal("image"),
    desktopImage: ImageSchema,
    mediumImage: OptionalImageSchema.optional(),
    smallImage: ImageSchema,
  })
);

const HeroWithVideoSchema = HeroBaseSchema.merge(
  z.object({
    backgroundType: z.literal("video"),
    videoFileReference: z.string(),
    tabletVideoFileReference: z.string(),
    mobileVideoFileReference: z.string(),
  })
);

export const HeroDataSchema = z.discriminatedUnion("backgroundType", [
  HeroWithImageSchema,
  HeroWithVideoSchema,
]);
